/**
 * カードの型番の取得（Issue #951）: 型番（収録パック）とレアリティの候補は Yugipedia から本番が取る（`card_sets.py`）。
 * ふだんは見回りが週 1 回と、まだ取っていないカードがあるときに取る。ここでは状態を見て、今すぐ取り直せる。
 */
import { useCallback, useEffect, useState } from 'react';
import { api } from '../api/api';

const POLL_MS = 3000;
const STATUS_LABEL = { processing: '取得中', pending: '取得中', completed: '完了', failed: '失敗', cancelled: '中止' };

export default function CardSetsSyncPanel({ onDone }) {
  const [state, setState] = useState(null);
  const [error, setError] = useState(null);

  const load = useCallback(() => api.project('GetCardSetsStatus')
    .then((r) => { setState(r); setError(null); return r; })
    .catch((err) => { setError(err.message); return null; }), []);
  useEffect(() => { load(); }, [load]);

  const job = state?.job;
  const running = job?.status === 'processing' || job?.status === 'pending';
  useEffect(() => {
    if (!running) return undefined;
    const timer = setInterval(async () => {
      const now = await load();
      const st = now?.job?.status;
      if (st && st !== 'processing' && st !== 'pending') onDone?.();
    }, POLL_MS);
    return () => clearInterval(timer);
  }, [running, load, onDone]);

  const start = async () => {
    try {
      await api.project('CreateCardSetsSyncRequest', { mode: 'all' });
      await load();
    } catch (err) { alert('始められませんでした: ' + err.message); }
  };

  return (
    <div style={{ marginTop: 32 }} data-testid="card-sets-sync">
      <h2 style={{ fontSize: '1rem', marginBottom: 4, color: '#aaa' }}>型番の候補（Yugipedia から）</h2>
      <div className="card-meta" style={{ marginBottom: 8 }}>
        使うカード（画像・デッキ・カードの表にあるもの）の型番とレアリティを Yugipedia から取ります。週 1 回と、新しいカードが入ったときに自動で取ります。
      </div>
      {error && <p className="loading">状態が取れません: {error}</p>}
      {state && (
        <div style={{ display: 'flex', gap: 12, alignItems: 'center', flexWrap: 'wrap' }}>
          <span data-testid="card-sets-counts">
            対象 {state.targets} 枚・取得済み {state.fetched} 枚
            {state.not_found > 0 && `（Yugipedia に見つからない ${state.not_found} 枚）`}
          </span>
          {job && (
            <span className="card-meta" data-testid="card-sets-job">
              #{job.id} {STATUS_LABEL[job.status] ?? job.status}{job.progress && `：${job.progress}`}
              {job.error_message && `（${job.error_message}）`}
            </span>
          )}
          <button className="btn btn-secondary btn-sm" disabled={running} onClick={start}>今すぐ取り直す</button>
        </div>
      )}
    </div>
  );
}
